import React from 'react'; 
import {Glyphicon} from 'react-bootstrap';
import {injectIntl} from 'react-intl';


function MeetingPlace({meeting, intl}){ 
  let place = "";
  if( meeting.online || meeting.modality == "online" ){
    place = intl.formatMessage({id: "online"});
  }
  else{
    place = meeting.place;
  }
  return ( 
    <span>
      <Glyphicon glyph="map-marker" />&nbsp;&nbsp;
      <span>{place}&nbsp;</span>
    </span>
  );
}

export default injectIntl(MeetingPlace);